import { dataConfig } from 'data/dataConfig';
import {
	getEntryKey,
	parseEntryKey,
	getPrimarySourcedMenuConfigForDataSet,
} from 'utils/primarySourcedDataSets';

import './DataSourceSelect.css';

function DataSourceSelect({
	dataSet,
	dataSource,
	propertyData,
	sourceCounts,
	onSourceChange,
	isDisabled,
}) {
	const menuConfig = getPrimarySourcedMenuConfigForDataSet(dataSet);
	if (!menuConfig) {
		return null;
	}

	const currentKey = getEntryKey(dataSet, dataSource);

	return (
		<select
			className="form-select data-source-select"
			value={currentKey}
			disabled={isDisabled}
			onChange={(e) => {
				const { dataSet: nextDataSet, dataSource: nextSource } = parseEntryKey(
					e.target.value
				);
				onSourceChange(nextDataSet, nextSource);
			}}
			aria-label="Data source"
		>
			{menuConfig.entries.map((entry) => {
				const entryKey = getEntryKey(entry.dataSet, entry.dataSource);
				let count = sourceCounts?.[entryKey];
				if (count === undefined || count === null) {
					const countField =
						dataConfig[entry.dataSet]?.openIssueCountFields?.[entry.dataSource];
					count = parseInt(propertyData?.[countField]) || 0;
				}
				return (
					<option key={entryKey} value={entryKey}>
						{entry.label} ({count})
					</option>
				);
			})}
		</select>
	);
}

export default DataSourceSelect;
